var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_content"},[_c('el-page-header',{staticClass:"page_section_card",attrs:{"content":"Facebook分类设置"},on:{"back":_vm.goBack}}),_c('el-card',[_c('section',{staticClass:"display_flex",staticStyle:{"width":"100%"}},[_c('fb-classify-comp'),_c('el-divider',{attrs:{"direction":"vertical"}}),_c('tags-comp')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }